import { EffectsMapObject, routerRedux } from "dva";
import { ReducersMapObject } from "redux";
import { freeze } from "immer";

import { crypt, CoreState, CoreEffects, CoreReducers, getLocalStorage } from "@reco-m/core";
import { app, getParkCode, mtaH5Click, statisticsEvent } from "@reco-w/core-ui";

import { Namespaces as authUserNamespaces } from "@reco-w/auth-user-models";
import { Namespaces as commonNamespaces } from "@reco-w/common-models";
import { parkService } from "@reco-w/home-service";
import { loginService, addMemberService, authQrHttpService, loginSMSService } from "@reco-w/auth-service";

import { Namespaces } from "./common";
import { getRandomKey } from "./utils";

export namespace loginModel {
    export const namespace = Namespaces.login;

    export const state: any = freeze(
        {
            ...CoreState,
            rememberPSW: true,
            showMore: true,
            isMobileLogin: false,
            QRCodeKey: getRandomKey(),
        },
        !0
    );

    export type StateType = typeof state;
    export const reducers: ReducersMapObject = {
        ...CoreReducers,
        initState() {
            return state;
        },
    };
    export const effects: EffectsMapObject = {
        ...CoreEffects,
        *initPage({}, { put }) {
            yield put({ type: "hideLoading" });
        },

        /**
         * 获取验证码
         * @param { message, delay, data }
         * @param { call }
         */
        *sendVerifyCode({ message, delay, data }, { call }) {
            const cleardelay = delay();
            try {
                yield call(loginSMSService.getLoginCode, {
                    response_type: "mobile",
                    scope: "",
                    ...data,
                });
            } catch (e) {
                message!.error(`${e?.errmsg || e}`);
                cleardelay();
            }
        },

        /**
         * 验证码登录
         * @param {  message, errCallBack, callback, isModal }
         * @param { call, put }
         */
        *smsLogin({ message, errCallBack, callback, isModal }, { call, put, select }) {
            try {
                yield put({ type: "input", data: { isLogin: true } });
                const data = yield select(({ login }) => login),
                    { phone, authcode } = data;

                const token = yield call(loginSMSService.loginNew, { username: phone, code: authcode });

                loginSMSService.refreshToken(token, server.auth!.autoRefreshToken);

                yield put({ type: "afterLogin", isModal, callback });
            } catch (e) {
                errCallBack && errCallBack();
                yield put({ type: "input", data: { loading: false } });
                message!.error(`${e?.errmsg || e}`);
            } finally {
                yield put({ type: "input", data: { isLogin: false } });
            }
        },

        /**
         * 提交登录
         */
        *submit({ message, isModal, callback }, { call, put, select }) {
            try {
                yield put({ type: "input", data: { isLogin: true } });
                const data = yield select(({ login }) => login),
                    { loginName, password, rememberPSW } = data;

                const cryptPassword = crypt(password);

                const login = {
                        encryMode: server["rsa"]?.enable ? 1 : 0,
                        username: loginName,
                        password: cryptPassword,
                    },
                    token = yield call(loginService.login, login);
                loginService.refreshToken(token, server.auth!.autoRefreshToken);
                rememberPSW && loginService.refreshUID(login);

                yield put({ type: "afterLogin", isModal, callback });
            } catch (e) {
                yield call(message!.error, e.errmsg);
            } finally {
                yield put({ type: "input", data: { loading: false, isLogin: false } });
            }
        },

        /**
         * 登录之后
         * @param { isModal, callback }
         * @param { call, put }
         */
        *afterLogin({ isModal, callback }, { call, put }) {
            try {
                yield yield put({ type: `${authUserNamespaces.user}/cleanCurrentUser` });
                yield yield put({ type: `${commonNamespaces.memberCommon}/clean` });
                yield yield put({ type: `${commonNamespaces.workorderCommon}/clean` });
                yield yield put({ type: `${commonNamespaces.consumerCommon}/clean` });
                let parkId = getLocalStorage("parkId");
                let parkName = getLocalStorage("parkName");
                if (!parkId || !parkName) {
                    const items = yield call(parkService.list);
                    if (items?.length > 0) {
                        parkId = items[0].id;
                        parkName = items[0].parkName;
                    }
                }
                mtaH5Click(statisticsEvent.accountLoginSuccess);
                if (!isModal) {
                    let path = getLocalStorage("selectedMenu");

                    path = path ? "/" + getParkCode() + path : "/" + getParkCode();

                    yield put(routerRedux.replace(path));
                }
                yield put({ type: "config" });
                if (callback) {
                    yield call(callback);
                }
            } catch (error) {}
        },

        *config({}, { call, put, select }) {
            try {
                yield yield put({ type: `${commonNamespaces.memberCommon}/getCertify`, isRefreshUser: true });
                const memberCommonState: any = yield select((state) => state[commonNamespaces.memberCommon]);
                const user = memberCommonState.user;
                const currentUser = user.currentUser;
                if (currentUser.id) {
                    // 登录添加会员
                    yield call(addMemberService.addMember, currentUser.id);
                }
            } catch (error) {}
        },
        /**
         * 检查二维码是否与用户有绑定
         */
        *checkQRCodeBindUser({ data }, { call, put }) {
            try {
                const result = yield call(authQrHttpService.checkToken, data);

                if (result && result.token) {
                    const token = result.token;

                    loginService.refreshToken({ token_str: token }, server.auth!.autoRefreshToken);

                    yield yield put({ type: `${commonNamespaces.memberCommon}/clean` });
                    yield yield put({ type: `${commonNamespaces.workorderCommon}/clean` });

                    yield yield put({ type: `${commonNamespaces.memberCommon}/refreshCurrentUser` });

                    yield put({ type: "input", data: { loading: false } });

                    mtaH5Click(statisticsEvent.scanLoginSuccess);

                    let path = getLocalStorage("selectedMenu");
                    path = path ? "/" + getParkCode() + path : "/" + getParkCode();

                    yield put(routerRedux.replace(path));

                    yield put({ type: "config", params: { parkName: getLocalStorage("parkName"), parkId: getLocalStorage("parkId"), AccountID: token.uid } });
                }
            } catch (error) {}
        },
    };
}

app.model(loginModel);
